"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useViewSetup = void 0;
var ScrollMethods = _interopRequireWildcard(require("../../utils/scroll"));
var _array = require("../type-checks/array");
var _boolean = require("../type-checks/boolean");
var _object = require("../type-checks/object");
var _string = require("../type-checks/string");
var _reactRouterDom = require("react-router-dom");
var _analytics = require("../analytics");
var _react = require("react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Hook to set page title and ensure Google Tags are active
 *
 * @name useViewSetup
 * @param {object} analyticsObject Data to configure title and analytics
 * @param {object} setup Optional object of configuration options
 * @param {array} setup.classNames Array of class names to add to the document.body on render
 * @param {boolean} setup.isScrollReset Resets window position to top, to disable set to false
 * @returns {object} Pointer to analyticsObject if passed (or empty object if not present)
 */
const useViewSetup = (analyticsObject, setup) => {
  let isObjectProvided = (0, _object.isObject)(analyticsObject),
    settingObject = isObjectProvided ? analyticsObject : {};
  const {
      analyticsEventData,
      clientName = "Generic",
      environment,
      eventName,
      googleId,
      prevailOnUnmount = false,
      title
    } = settingObject,
    location = (0, _reactRouterDom.useLocation)(),
    defaultTitle = (0, _react.useRef)((0, _string.isStringOfLength)(clientName) ? clientName : "Generic");
  (0, _react.useEffect)(() => {
    if ((0, _string.isStringOfLength)(googleId) && !(0, _analytics.isGTAGInitialized)()) {
      (0, _analytics.injectGATags)(googleId);
    }
    if ((0, _string.isStringOfLength)(title) && !prevailOnUnmount) {
      document.title = title;
    } else {
      document.title = defaultTitle.current;
    }
  }, [googleId, prevailOnUnmount, title]);
  (0, _react.useEffect)(() => {
    if ((0, _object.isObject)(setup) && (0, _array.isArrayOfLength)(setup.classNames)) {
      setup.classNames.forEach(className => {
        if ((0, _string.isStringOfLength)(className)) {
          document.body.classList.add(className);
        }
      });
    }
    ;
    return () => {
      if ((0, _object.isObject)(setup) && (0, _array.isArrayOfLength)(setup.classNames)) {
        setup.classNames.forEach(className => {
          if ((0, _string.isStringOfLength)(className)) {
            document.body.classList.remove(className);
          }
        });
      }
      ;
    };
  }, [setup]);
  (0, _react.useLayoutEffect)(() => {
    (0, _analytics.createVirtualPageViewGA4)(eventName, analyticsEventData, environment);
  }, [eventName, analyticsEventData, environment, title]);
  (0, _react.useLayoutEffect)(() => {
    let targetElem = null;

    // Scroll to element if in page and in URL hash;
    if ((0, _string.isStringOfLength)(location.hash)) {
      targetElem = document.querySelector(location.hash);
      if (targetElem) {
        ScrollMethods.scrollToElement(targetElem);
      }

      // Else scroll to top of the page, simulating a page load by a browser;
    } else if (typeof window?.scrollTo === "function" && (!(0, _object.isObject)(setup) || !(0, _boolean.isBoolean)(setup.isScrollReset) || setup.isScrollReset === true)) {
      window.scrollTo({
        behavior: "instant",
        left: 0,
        top: 0
      });
    }
  }, [setup, location.hash]);
  return isObjectProvided;
};
exports.useViewSetup = useViewSetup;